// Leave-page warning (2026-10-13, owner request; narrowed 2026-10-14 to unsaved changes only):
// the browser asks "Leave site?" before the app is closed, reloaded or left (pull-to-refresh,
// backing out of the app, a mistyped address) only while something typed or picked on the page
// has not been saved yet. Moving between screens inside the app never unloads the page, so it
// never asks there. Browsers show their own fixed wording.
let allowUntil = 0;
const edited = new Map(); // field -> its value before the user started changing it

// Call right before an intentional full-page navigation (phone link, sign-out redirect).
export function allowLeave(ms = 3000) {
  allowUntil = Date.now() + ms;
}

function signedIn() {
  try {
    return Boolean(localStorage.getItem('isAuthenticated') || localStorage.getItem('techAuthenticated'));
  } catch (e) {
    return false;
  }
}

function isField(el) {
  return Boolean(el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT' || el.isContentEditable));
}

// Search boxes and filters are not work that can be lost.
function ignored(el) {
  if (el.closest && el.closest('[data-leave-ok]')) return true;
  const type = (el.type || '').toLowerCase();
  if (['search', 'password', 'hidden', 'file', 'button', 'submit', 'reset'].includes(type)) return true;
  const hint = [el.name, el.id, el.placeholder, el.getAttribute && el.getAttribute('aria-label')].join(' ');
  return /search|filter|find/i.test(hint);
}

function valueOf(el) {
  if (el.type === 'checkbox' || el.type === 'radio') return String(el.checked);
  if (el.isContentEditable) return el.textContent;
  return el.value == null ? '' : String(el.value);
}

export function hasUnsavedChanges() {
  for (const [el, before] of edited) {
    if (!el.isConnected) { edited.delete(el); continue; }   // the form was closed or the screen changed
    if (!ignored(el) && valueOf(el) !== before) return true;
  }
  return false;
}

// After a successful save, what is on the screen is the saved state.
export function markSaved() {
  for (const el of edited.keys()) edited.set(el, valueOf(el));
}

export function shouldWarn() {
  return Date.now() >= allowUntil && signedIn() && hasUnsavedChanges();
}

export function installLeaveGuard() {
  document.addEventListener('focusin', (event) => {
    const el = event.target;
    if (event.isTrusted && isField(el) && !edited.has(el)) edited.set(el, valueOf(el));
  }, true);
  window.addEventListener('beforeunload', (event) => {
    if (!shouldWarn()) return;
    event.preventDefault();
    event.returnValue = '';
  });
  // Phone, text, e-mail and download links hand off to another app; the page itself stays.
  document.addEventListener('click', (event) => {
    const link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (!link) return;
    const href = link.getAttribute('href') || '';
    if (/^(tel|sms|mailto):/i.test(href) || link.hasAttribute('download')) allowLeave();
  }, true);
}
